import { constAccessType } from '@/modules/Constant.js'

const state = {
    userData_: [],
    acl_: {},
    memberSearchCriteria_: {
        agi: null
    },
    menuDisplayType_: localStorage.getItem('isSimpleMode') === 'True' ? 1 : 0,
}
const getters = {
    getUserInfo: state => {
        return state.userData_
    },
    getMenuDisplayType: state => {
        return state.menuDisplayType_
    },
    checkMenuAccess: (state) => (parentModuleName) => {
        var access = false;
        var user = state.userData_;
        var acl = state.acl_;
        if (acl || (user && user.ACL)) {
            try {
                if (parentModuleName in acl && acl[parentModuleName]) {
                    for (var key in acl[parentModuleName]) {
                        if (key != parentModuleName && acl[parentModuleName].hasOwnProperty(key) && acl[parentModuleName][key].includes(1)) {
                            access = true;
                            break;
                        }
                        else if (((parentModuleName == 'D' && key == 'MD') || (parentModuleName == 'W' && key == 'MW')) && acl[parentModuleName].hasOwnProperty(key) && acl[parentModuleName][key].includes(2)) {
                            access = true;
                            break;
                        }
                    }
                }
            }
            catch (e) {
                // if new method have exception, use back the old logic below
                for (var i = 0; i < user.ACL.length; i++) {
                    if (user.ACL[i].PMS == parentModuleName && user.ACL[i].PMS != user.ACL[i].MNS && user.ACL[i].AT == 1) {
                        access = true;
                        break;
                    }
                }
            }
        }

        return access;
    },
    checkModuleAccess: (state) => (moduleName, parentModuleName, accessType) => {
        var access = false;
        var user = state.userData_;
        var acl = state.acl_;
        if (acl || (user && user.ACL)) {
            try {
                if (parentModuleName in acl && acl[parentModuleName] &&
                    moduleName in acl[parentModuleName] && acl[parentModuleName][moduleName]) {
                    access = acl[parentModuleName][moduleName].includes(accessType);
                }
            }
            catch (e) {
                // if new method have exception, use back the old logic below
                for (var i = 0; i < user.ACL.length; i++) {
                    if (user.ACL[i].MNS == moduleName && user.ACL[i].PMS == parentModuleName && user.ACL[i].AT == accessType) {
                        access = true;
                        break;
                    }
                }
            }
        }
        return access;
    },
    checkModuleIndex: (state) => (moduleName, parentModuleName, accessType = 1, subModuleName = '', subMenuIndex = 0) => {
        var moduleIndex = "";
        var user = state.userData_;
        var acl = state.acl_;
        if (acl || (user && user.ACL)) {
            try {
                const filteredResult = user.ACL.find((e) => e.MNS == moduleName && e.PMS == parentModuleName && e.AT == accessType && e.DT == state.menuDisplayType_);
                if(subMenuIndex == 0){
                    moduleIndex = filteredResult.MPI + '.' + filteredResult.SPI
                }
                else if(subMenuIndex < 0){
                    moduleIndex = filteredResult.MPI + '.' + filteredResult.SMI + '.' + filteredResult.SPI
                }
                else{
                    // if(subModuleName == ''){
                    //     subModuleName = filteredResult.SPM;
                    // }
                    // const distinctSPM = [...new Set(user.ACL.filter( d => d.PMS == parentModuleName).map(x => x.SPM).sort())];
                    // subMenuIndex = distinctSPM.indexOf(subModuleName, 0)
                    moduleIndex = filteredResult.MPI + '.' + subMenuIndex + '.' + filteredResult.SPI
                }
                
            }
            catch (e) {
                // if new method have exception, use back the old logic below
                for (var i = 0; i < user.ACL.length; i++) {
                    if (user.ACL[i].MNS == moduleName && user.ACL[i].PMS == parentModuleName && user.ACL[i].AT == accessType && e.DT == state.menuDisplayType_) {
                        moduleIndex = user.ACL[i].MPI + '.' + user.ACL[i].SPI
                        break;
                    }
                }
            }
        }
        return moduleIndex;
    },
    checkSubModuleAccess: (state) => (subParentModule) => {
        var access = false;
        var user = state.userData_;
        if (user && user.ACL) {
            access = user.ACL.some( item => item['SPM'] === subParentModule);
        }
        return access;
    },
    checkSubModuleIndex: (state) => (menuIndex, ModuleName, subModuleName, subModuleIndex) => {
        // var moduleIndex = "";
        // var user = state.userData_;
        // if (user && user.ACL) {
        //     const distinctSPM = [...new Set(user.ACL.filter( d => d.PMS == ModuleName).map(x => x.SPM).sort())];
        //     moduleIndex = distinctSPM.indexOf(subModuleName, 0);
        // }
        return menuIndex + '.' + subModuleIndex;
    },
    getUserMemberSC: state => {
        return state.memberSearchCriteria_;
    },
}
const mutations = {
    setUser(state, value) {
        state.userData_ = value;
        var user = state.userData_;
        var sc = state.memberSearchCriteria_;
        if (sc.agi && user && user.AGL) {
            var isExist = false;
            for (var i = 0; i < user.AGL.length; i++) {
                if (user.AGL[i].I == sc.agi) {
                    isExist = true;
                    break;
                }
            }

            if (!isExist) {
                sc.agi = null;
            }
        }

        state.acl_ = {};
        if (user && user.ACL) {
            for (var i = 0; i < user.ACL.length; i++) {
                if (!(user.ACL[i].PMS in state.acl_)) {
                    state.acl_[user.ACL[i].PMS] = {};
                }

                if (!(user.ACL[i].MNS in state.acl_[user.ACL[i].PMS])) {
                    state.acl_[user.ACL[i].PMS][user.ACL[i].MNS] = [];
                }

                state.acl_[user.ACL[i].PMS][user.ACL[i].MNS].push(user.ACL[i].AT);
            }
        }
    },
    setSearchCriteriaAGI(state, value) {
        state.memberSearchCriteria_.agi = value;
    },
    setMenuDisplayType(state, value) {
        state.menuDisplayType_ = value;
    }
}
const actions = {
    setUser({ commit }, value) {
        commit('setUser', value)
    },
    setSearchCriteriaAGI({ commit }, value) {
        commit('setSearchCriteriaAGI', value)
    },
    setMenuDisplayType({ commit }, value) {
        commit('setMenuDisplayType', value)
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/UserInfo.js